<template>
  <div class="footer-container row">
    <div class="main" @click="goTo">京ICP备18009005号-6</div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    goTo() {
      window.open('http://beian.miit.gov.cn/');
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-container {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 28px;
  background-color: #5d5c68;
  font-size: 12px;
  .main {
    color: #d1d2da;
    cursor: pointer;
    &:hover {
      color: #d1d2da;
    }
  }
}
</style>
